import { ProfOfferFlat, ProfOfferInfrastructure, BuildEpochEnum, BuildHeatingTypeEnum } from '@search/graphql-typings';

import {
    getApartments,
    getBuildYear,
    getCeilingHeightM,
    getClosedArea,
    getConsierge,
    getFinishQuarter,
    getGarbage,
    getHasLift,
    getParking,
    getWallsType,
    getRenovationProgram,
    getBuildEpoch,
    getHeatingType
} from './infoHelpers';
import { mapToInformations, InfoModelRaw, InformationsEnum, TGenerateSeoUrlParams } from './infoHelpers/types/InfoModel';

export const buildInfoBuilding = (
    flat?: ProfOfferFlat,
    infrastructure?: ProfOfferInfrastructure,
    params?: {
        isRenovationProgram?: boolean;
        buildSeries?: string;
        buildEpoch?: BuildEpochEnum;
        buildHeating?: BuildHeatingTypeEnum;
        buildB2cInfo?: boolean;
        generateUrl?: (params: TGenerateSeoUrlParams) => string;
    }
) => {
    const buildYear = getBuildYear(flat);
    const ceilingHeightM = getCeilingHeightM(flat);
    const hasLift = getHasLift(flat);
    const consierge = getConsierge(infrastructure);
    const apartments = getApartments(flat);
    const finishQuarter = getFinishQuarter(flat);
    const renovationProgram = getRenovationProgram(params?.isRenovationProgram);

    let builtYear = {
        title: 'Срок сдачи',
        value: finishQuarter,
        key: InformationsEnum.finishQuarter
    };

    if (buildYear) {
        builtYear = {
            title: 'Год постройки',
            value: buildYear,
            key: InformationsEnum.buildYear
        };
    }

    const informationsRaw: InfoModelRaw[] = [
        builtYear,
        {
            title: 'Временная эпоха',
            value: getBuildEpoch(params?.buildEpoch),
            key: InformationsEnum.buildEpoch
        },
        {
            title: 'Серия дома',
            value: params?.buildSeries,
            key: InformationsEnum.buildSeries
        },
        {
            title: 'Высота потолков',
            value: ceilingHeightM,
            key: InformationsEnum.ceilingHeightM
        },
        {
            title: 'Реновация',
            value: renovationProgram,
            key: InformationsEnum.renovationProgram
        },
        {
            title: 'Лифт',
            value: hasLift,
            key: InformationsEnum.hasLift
        },
        ...getWallsType(flat),
        {
            title: 'Отопление',
            value: getHeatingType(params?.buildHeating),
            key: InformationsEnum.buildHeatingType
        },
        ...getParking(infrastructure),
        {
            title: 'Консьерж',
            value: consierge,
            key: InformationsEnum.concierge
        },
        ...getClosedArea(infrastructure),
        ...getGarbage(flat),
        ...(params?.buildB2cInfo ?
            [] :
            [ {
                title: 'Апартаменты',
                value: apartments,
                key: InformationsEnum.apartments
            } ]
        ),
    ];

    return mapToInformations(informationsRaw, params);
};
